export const getSgConnectToken = async () => {
  let intervalId: NodeJS.Timeout;
  return new Promise<string | undefined>((resolve) => {
    intervalId = setInterval(() => {
      const busToken = window.SGWTWidgetConfiguration.bus.dangerouslyGetCurrentValue<string | undefined>('sg-connect.access-token');
      if (busToken) {
        clearInterval(intervalId);
        resolve(busToken);
      }

      const sgwtConnect = window.sgwtConnect || document.querySelector('sgwt-connect')?.sgwtConnect;
      if (sgwtConnect) {
        if (intervalId) {
          clearInterval(intervalId);
        }
        const token = sgwtConnect.getAuthorizationHeader();
        if (token) {
          resolve(token);
        }
      }
    }, 500);
  }).then((result: string | undefined) => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    return result;
  });
};

export const getUserInfo = async () => {
  let intervalId: NodeJS.Timeout;
  return new Promise<IUserInfo | undefined>((resolve, reject) => {
    intervalId = setInterval(() => {
      const sgwtConnect = window.sgwtConnect || document.querySelector('sgwt-connect')?.sgwtConnect;
      if (sgwtConnect) {
        if (intervalId) {
          clearInterval(intervalId);
        }
        sgwtConnect.fetchUserInfo((error, claims) => {
          if (error) {
            return reject(error);
          }

          return resolve(claims);
        });
      }
    }, 500);
  }).then((result: IUserInfo | undefined) => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    return result;
  });
};

export interface IUserInfo {
  sub: string;
  locale: string;
  name: string;
  zoneinfo?: string;
  postal_country?: string;
  mail?: string;
  igg?: string;
  last_name?: string;
  login_ad?: string;
  company_bdr_name?: string;
  given_name?: string;
  contact_id?: string;
  sgconnect_id?: string;
  rc_local_sigle?: string;
  sesame_id?: string;
  user_bdr_id?: string;
  company_bdr_level?: string;
  is_sg_group_user?: string;
  family_name?: string;
  first_name?: string;
  company_bdr_id?: string;
  preferred_language?: string;
  origin_network?: 'LAN' | 'WAN' | 'Internet';
  auth_level?: 'L1' | 'L2' | 'L3' | 'L4';
};
